import { render } from "./AdmCreatePlansLivre.vue?vue&type=template&id=6f0eb576&scoped=true&ts=true"
import script from "./AdmCreatePlansLivre.vue?vue&type=script&lang=ts"
export * from "./AdmCreatePlansLivre.vue?vue&type=script&lang=ts"

import "./AdmCreatePlansLivre.vue?vue&type=style&index=0&id=6f0eb576&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0eb576"]])

export default __exports__